export default {
  placeholders: {
    delivery_zip_code: 'Cod poștal',
    delivery_city: 'Oraș',
    delivery_street_number: 'Număr stradă',
    delivery_street_name: 'Nume stradă',
    type_your_address: 'Introduceți adresa',
  },
  errors: {
    address_suggestions_unavailable:
      'Sugestiile de adrese nu au putut fi încărcate. Îți poți introduce adresa mai jos.',
  },
  buttons: {
    retry: 'Încearcă din nou',
  },
};
